<template>
	<div class="page-container flex-column">
		<main class="main flex-column flex1">
			<!-- 专家信息 -->

			<div class="expert-wrapper">
				<div class="user-info">
					<van-image class="avatar" width="50" height="50" round lazy-load fit="cover" :src="expertDetail.photo" />
					<div class="text-box">
						<div class="user-info__name">{{ expertDetail.name }}</div>
						<div class="user-info__tags tags-box">
							<span class="user-info__tag tag" v-for="(tag, index) in expertDetail.labelNameList" :key="index">{{
								String(tag).length > 6 ? `${String(tag).slice(0, 6)}...` : tag
							}}</span>
						</div>
					</div>
				</div>

				<div class="brief-intro-box" :style="{marginTop: expertDetail.labelNameList ? '5px' : '10px'}" v-if="expertDetail.introduce">
					<div class="brief-intro">
						<MultiLineExpandsCollapses id="intro" :content="expertDetail.introduce" />
					</div>
				</div>
			</div>

			<!-- 内容列表 -->
			<div class="content-list-box">
				<div class="title-line">
					<div class="box-title title-line-left">专家内容</div>
				</div>
				<van-list
					v-model="loading"
					:finished="finished"
					:finished-text="list.length ? '没有更多了' : ''"
					@load="onLoad">
					<van-empty
						v-if="!list.length && !loading"
						class="custom-image"
						:image="require('@/assets/image/ic_search.png')"
						:image-size="114"
						description="暂无内容～" />

					<div class="card-wrapper" v-else>
						<Card
							class="card"
							v-for="item in list"
							:key="item.id"
							@click="handleClickJumpDetailsPageByResourceType(item)"
							lazy-load
							currency=""
							:tag="resourceType[item.resourceType]"
							:thumb="item.cover"
							:headerStyle="{ width: 'calc(100vw / 2 - 20px)', borderRadius: '5px', flexDirection: 'column' }"
							:thumbStyle="{ width: '100%', height: '103px' }">
							<template #title>
								<span class="card-title text van-ellipsis block">{{ item.name }}</span>
							</template>
							<template #price>
								<p v-if="item.price > 0">
									<span class="price">{{ item.price }}</span>
									<span class="unit"> 巢币 </span>
								</p>
								<p v-else>
									<span class="price"> 免费 </span>
								</p>
							</template>
						</Card>
					</div>
				</van-list>
			</div>
		</main>
	</div>
</template>

<script>
import WxShare from "@/utils/wxshare";
import Card from "./components/Card.vue";
import MultiLineExpandsCollapses from "./components/MultiLineExpandsCollapses.vue";
import { getImageUrl, isHttp } from "@/utils/upload";
import { educbase } from '@/utils/http';
import utils from '@/utils/utils.js';

// 指派类型 0：课程 1：培训计划
const ASSIGN_TYPE = {
	0: "课程",
	1: "培训计划"
};

export default {
	components: {
		Card,
		MultiLineExpandsCollapses
	},

	data() {
		return {
			resourceType: Object.freeze(ASSIGN_TYPE), // 资源类型
			list: [], // 列表数据
			loading: false,
			finished: false,
			page: 1,
			pageSize: 10,
			total: 0,
			expertDetail: {}, // 专家详情
			tenantId: "" // 租户id
		};
	},

	created() {
		this.getExpertInfo();
		this.init();
	},

	methods: {
		init() {
			this.getWx = new WxShare();
		},

		/**获取专家信息 */
		getExpertInfo() {
			const data = new FormData();
			data.append("api", "kc/app/cTrain/expertDetail");
			data.append("id", this.$route.query.id);

			this.$http({
				url: "/ipd/commonApi",
				method: "post",
				data
			}).then((res) => {
				if (res.code < 0) {
					return this.$router.replace({
						path: "/learningEmpty"
					});
				}

				if (!utils.browserChecker.isMobile()) {
					window.location.href = educbase + '/learning/expertInfo?id=' + this.$route.query.id+ '&relateTenantId=' + res.data.relateTenantId;
				}

				// 专家所属租户,用于查询内容列表
				this.tenantId = res.data.relateTenantId;

				this.expertDetail = res.data || {};

				// 改变h5标题
				document.title = this.expertDetail.name || "课程详情";

				new Promise((resolve) => {
					// 封面
					if (this.expertDetail?.photo && !isHttp(this.expertDetail.photo)) {
						getImageUrl(this.expertDetail.photo, resolve);
					} else {
						resolve(require("@/assets/image/expert_head.png"));
					}
				}).then((imgUrl) => {
					this.$set(this.expertDetail, "photo", imgUrl);

					/* 微信分享 */
					this.getWx.share({
						title: this.expertDetail.name,
						desc: "电子产业链人才智慧培养和提升一站式数字化服务平台",
						link: window.location.href,
						imgUrl
					});
				});
			});
		},

		onLoad() {
			const data = new FormData();
			data.append("api", "kc/app/cTrain/resource/list");
			data.append("page", this.page);
			data.append("pageSize", this.pageSize);
			// 租户id 和 专家id 至少传一个，后端会根据专家id反查租户id并返回数据
			data.append("expertId", this.tenantId); // 租户id
			data.append("lecturerId", this.$route.query.id); //  专家id

			this.$http({
				url: "/ipd/commonApi",
				method: "post",
				data
			}).then((res) => {
				if (res.code < 0) {
					return this.$router.replace({
						path: "/learningEmpty"
					});
				}

				this.loading = false;
				if (this.list.length >= res.data.total) return (this.finished = true);
				this.list.push(...(res.data.items || []));
				this.page = this.page + 1;

				if (this.list.length > 0) {
					this.list.forEach((item) => {
						if (item.cover && !isHttp(item.cover)) {
							getImageUrl(item.cover, (imgUrl) => {
								this.$set(item, "cover", imgUrl);
							});
						}
					});
				}
			});
		},

		/**
		 * 点击卡片根据资源类型跳转到对应资源的详情页
		 */
		handleClickJumpDetailsPageByResourceType(item) {
			// 0：课程 1：培训计划
			if (Number(item.resourceType) === 1) {
				this.$router.push({
					path: "/training",
					query: { trainId: item.id }
				});
			} else {
				this.$router.push({
					path: "/trainingCourse",
					query: { courseId: item.id }
				});
			}
		}
	}
};
</script>

<style scoped>
.page-container {
	--color-primary: #f7433f;
}

.page-container {
	height: 100vh;
	background-color: #f7f8f8;
}
.flex-column {
	display: flex;
	flex-direction: column;
}
.flex1 {
	flex: 1;
	overflow-y: auto;
}

.header /deep/.headerMod {
	border: 0;
}

.main::-webkit-scrollbar {
	display: none;
}

/* 专家 */
.expert-wrapper {
	background-color: #fff;
	padding: 10px 15px;
}

.user-info {
	display: flex;
	align-items: center;
	margin-top: 5px;
}

.avatar {
	justify-content: stretch;
	align-self: self-start;
	flex-shrink: 0;
}

.user-info .text-box {
	margin-left: 13px;
}
.user-info__name {
	font-weight: 500;
	font-size: 17px;
	color: #333333;
	margin-bottom: 5px;
}
.tags-box {
	font-size: 12px;
	color: #999999;
	display: flex;
	flex-wrap: wrap;
	/* gap: 5px; */
}

.tag {
	margin-right: 5px;
	margin-bottom: 5px;
	padding: 5px 10px;
	background: #f6f6f6;
	border-radius: 12px;
}

.brief-intro-box {
	font-size: 13px;
	color: #555555;
	line-height: 18px;
	text-align: justify;
	background-color: #fff;
	/* margin-top: 10px; */
}

/* 专家内容 */
.content-list-box {
	margin-top: 10px;
	background-color: #fff;
	flex: 1;
	padding: 0 15px;
}

.content-list-box .box-title {
	font-size: 17px;
	font-weight: 500;
	color: #333333;
	padding: 8px 0;
}

.card-wrapper {
	display: flex;
	flex-wrap: wrap;
	/* gap: 15px 10px; */
}

.card {
	margin-bottom: 15px;
}

.card:nth-child(even) {
	margin-left: 10px;
}

.block {
	display: block;
	width: 100%;
	margin-bottom: 7px;
}

.price,
.unit {
	color: var(--color-primary);
}

.price {
	font-size: 14px;
}

.unit {
	font-size: 10px;
	vertical-align: 1px;
}

/* 无内容 */
.custom-image /deep/.van-empty__description {
	margin-top: 0;
	font-size: 13px;
	color: #c0c4cc;
	line-height: 12px;
}
</style>
